import { ClockCounterClockwiseIcon, HourglassHighIcon } from '@phosphor-icons/react'
import type { ReactElement } from 'react'
import { HYGIENE_SORTS } from './hygieneBands'

/** The hygiene sorts with an icon each, so on a phone they shrink to icons like the rest. */
const HYGIENE_SORT_ICONS: Record<string, ReactElement> = {
  longest: <HourglassHighIcon size={14} weight="bold" />,
  recent: <ClockCounterClockwiseIcon size={14} weight="bold" />,
}
export const HYGIENE_SORT_OPTIONS = HYGIENE_SORTS.map((option) => ({ ...option, icon: HYGIENE_SORT_ICONS[option.id] }))
